var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{staticClass:"brand-logo",class:{ 'brand-logo--flealover': _vm.isGlobalApp },attrs:{"src":_vm.isGlobalApp ? require('@base/assets/images/flealover-sitelogo.png') : require('@base/assets/images/sitelogo.png'),"alt":_vm.appName}})
}
var staticRenderFns = []

export { render, staticRenderFns }